module.exports = __webpack_public_path__ + "img/maitain.5e4ef003.png";